
const etats = [
    {value: 'mvp', label: 'MVP'},
    {value: 'pre.seed.seed', label: 'Pre-seed / Seed'},
    {value: 'series.a.c', label: 'Series A - C'},
    {value: 'series.d.more', label: 'Series D & more'},
    {value: 'others', label: 'Others'}
    ];

export default etats;